import { Axios } from 'common/services';

export const getSkillsService = async () => {
  const res = await Axios.get('/SkillManagement/');
  return res.data;
};
export const createSkillsService = async (payload: { name: string; isPublic?: boolean }) => {
  const res = await Axios.post('/SkillManagement/', payload);
  return res.data;
};

export const updateSkillsService = async (id: string, payload: { name: string; isPublic?: boolean }) => {
  const res = await Axios.put(`/SkillManagement/${id}/`, payload);
  return res.data;
};

// export const deleteSkillsService = async (id: string) => {
//     const res = await Axios.delete(`/SkillManagement/${id}/`);
//     return res.data;
// };
